// Thin wrapper around the /funds/access/group/custom-group/... endpoints.
// Caller supplies a RemoteV2 instance (e.g. via useRemote()).

const BASE = 'funds/access/group/custom-group';

function requireFundId(fundId, op) {
    if (fundId == null) {
        // Surface the bug instead of quietly hitting `.../fund/undefined`.
        const msg = `customGroupsApi.${op}: fundId is required`;
        console.error(msg);
        return Promise.reject(new Error(msg));
    }
    return null;
}

export function makeCustomGroupsApi(remote) {
    return {
        list: () => remote.get(BASE),
        get: (id) => remote.get(`${BASE}/${id}`),
        create: ({ customGroupName, editMode } = {}) =>
            remote.post(BASE, { customGroupName, editMode }),
        update: (id, { customGroupName, editMode } = {}) =>
            remote.put(`${BASE}/${id}`, { customGroupName, editMode }),
        addFund: (id, fundId) =>
            requireFundId(fundId, 'addFund') || remote.post(`${BASE}/${id}/fund/${fundId}`),
        removeFund: (id, fundId) =>
            requireFundId(fundId, 'removeFund') || remote.delete(`${BASE}/${id}/fund/${fundId}`),
        deleteGroup: (id) =>
            remote.delete(`${BASE}/${id}`),
    };
}
